import { EditTechnicalDetails } from "./edit-technical-details";
import { ElectricalData } from "./electrical-data";
import { FrequencyParameter } from "./frequency-parameter";
import { VariantData } from "./variant-data";

export interface TechnicalDetails {
    id: number;
    gasGroup: string;
    exProtection: string;
    insulationClass: string;
    bearing: string;
    nonBearing: string;
    polesHigh: string;
    polesLow: string;
    imClass: string;
    temperatureClass: string;
    temperatureRiseClass: string;
    certificateNumber: string;
    altitude: number;
    ambientTemperature: number;
    typeOfDuty: string;
    frameSize: string;
    grossWeight: number;
    netWeight: number;
    icClass: string;
    ipClass: string;
    atexCategory: string;
    frequencyParameters: FrequencyParameter[];
    electricalData: ElectricalData[];
    variants: VariantData[];
  }

export function toEditModel(data: TechnicalDetails): EditTechnicalDetails {
    return {
        id: data.id,
        gasGroup: data.gasGroup,
        exProtection: data.exProtection,
        insulationClass: data.insulationClass,
        bearing: data.bearing,
        nonBearing: data.nonBearing,
        polesHigh: data.polesHigh,
        polesLow: data.polesLow,
        imClass: data.imClass,
        temperatureClass: data.temperatureClass,
        temperatureRiseClass: data.temperatureRiseClass,
        certificateNumber: data.certificateNumber,
        altitude: data.altitude,
        ambientTemperature: data.ambientTemperature,
        typeOfDuty: data.typeOfDuty,
        frameSize: data.frameSize,
        grossWeight: data.grossWeight,
        netWeight: data.netWeight,
        icClass: data.icClass,
        ipClass: data.ipClass,
        atexCategory: data.atexCategory,
        frequencyParameters: data.frequencyParameters.map(x => ({...x})) as FrequencyParameter[],
        electricalData: data.electricalData.map(x => ({...x})) as ElectricalData[],
        variants: data.variants.map(x => ({...x})) as VariantData[]
    };
}
